module.exports = __webpack_public_path__ + "static/media/Ramona Avenue, Albany, CA4.dab3b979.jpg";